module.exports = __webpack_public_path__ + "static/media/grant-permission.c0df590c.svg";